import { render } from "./disablable.vue?vue&type=template&id=4b2e5afe"
import script from "./disablable.vue?vue&type=script&lang=js"
export * from "./disablable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__